import type i18n from '@michelin/central-provider/dist/translations/CentralTranslation';
import { initMaestroTranslations } from '@michelin/maestro-common-translations';
import { initOptionsAndValuesTranslations } from '@michelin/select-options-provider';

let enUsTranslations: Record<string, string> | undefined;
let frCaTranslations: Record<string, string> | undefined;
let isModuleInitialized = false;

type InitMaestroTranslationsParameters = Parameters<typeof initMaestroTranslations>;
type InitializeTranslationsParameters = [
  Readonly<i18n.i18n>,
  Readonly<InitMaestroTranslationsParameters[1]>,
  Readonly<InitMaestroTranslationsParameters[3]>,
];

export const initializeTranslations = async (...args: InitializeTranslationsParameters) => {
  if (enUsTranslations === undefined) {
    try {
      const enUsTranslationsLoadPromise = await import('../i18n/en_US.json');
      enUsTranslations = enUsTranslationsLoadPromise.default;
    } catch (error) {
      throw new TypeError('Failed to load enUS translations');
    }
  }

  if (frCaTranslations === undefined) {
    try {
      const frCaTranslationsLoadPromise = await import('../i18n/fr_CA.json');
      frCaTranslations = frCaTranslationsLoadPromise.default;
    } catch (error) {
      throw new TypeError('Failed to load frCA translations');
    }
  }

  if (enUsTranslations !== undefined && frCaTranslations !== undefined && !isModuleInitialized) {
    try {
      const [translationLibInstance, translationReactModuleInstance, appendToGlobalScopeTranslations] = args;
      const resources = {
        en_US: enUsTranslations,

        fr_CA: frCaTranslations,
      } as const;

      initMaestroTranslations(translationLibInstance, translationReactModuleInstance, resources, [
        ...appendToGlobalScopeTranslations,
      ]);
      initOptionsAndValuesTranslations(translationLibInstance);

      isModuleInitialized = true;
    } catch (error) {
      throw new TypeError('Translations module failed to initialize!');
    }
  }
};
